import { render, staticRenderFns } from "./ComponentNotification.vue?vue&type=template&id=6da5047c"
import script from "./ComponentNotification.vue?vue&type=script&lang=js"
export * from "./ComponentNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports